import leaseContractApi from '@/api/park/leaseContract';
export default {
  data() {
    return {
      withdrawalType: '',
    };
  },
  methods: {
    chooseClick(type) {
      try {
        console.log(type);
        if (!this.isCheckCurrentCompanyBelongParkCompany()) {
          this.$message.error('当前公司不支持该操作');
          return;
        }
        this[type]();
      } catch (e) {
        console.error('当前方法不支持', e);
        this.$message.error(`${type}当前方法不支持,请联系开发人员`);
      }
    },
    // 新增方法
    addHandler() {
      console.log('新增');
      const path = {
        path: '/park/leaseContract/leaseDetail',
        name: 'leaseDetail',
        meta: {
          keepAlive: false,
          title: '三方仓库租赁合同维护',
        },
        query: {
          status: 'create',
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 审批
    approvalHandler() {
      this.approvalOrRejectHandler(1);
    },
    // 驳回按钮事件
    rejectHandler() {
      this.approvalOrRejectHandler(2);
    },
    approvalOrRejectHandler(type) {
      if (!this.checkSelectOneData()) {
        return;
      }
      const rowData = this.selectionList[0];
      const { contractStatus } = rowData;
      if (contractStatus != '02') {
        this.$message.error('只有待审批的单才可以操作');
        return;
      }
      this.$refs.approvalDialogRef.openDialog({ ...rowData, type });
    },
    // 关闭
    async closeHandler() {
      if (!this.checkSelectOneData()) {
        return;
      }
      const rowData = this.selectionList[0];
      const { id, contractStatus } = rowData;
      if (['01', '02', '04', '06'].includes(contractStatus)) {
        this.$message.error('当前合同状态不支持关闭');
      } else {
        await this.getSettlementList();
        this.$refs.closeContractDialogRef.openDialog(
          id,
          contractStatus,
          this.isCreate,
          this.isPaid
        );
      }
    },
    // 续签
    renewHandler() {
      if (!this.checkSelectOneData()) {
        return;
      }
      const rowData = this.selectionList[0];
      const { contractStatus, contractNo, id } = rowData;
      if (contractStatus != '03' && contractStatus != '06') {
        this.$message.error('当前合同状态不支持续签');
        return;
      }
      const path = {
        path: '/park/leaseContract/leaseContractRenew',
        name: 'leaseContractRenew',
        meta: {
          keepAlive: false,
          title: '三方仓库租赁合同续签',
        },
        query: {
          status: 'renew',
          contractNo,
          id,
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 变更主体
    changeHandler() {
      // 先走关闭,再复制一份合同出来生成一份新的
      if (!this.checkSelectOneData()) {
        return;
      }
      const rowData = this.selectionList[0];
      this.changeRowData = rowData; // 特殊保存下当前选中变更主体的行
      const { contractStatus } = rowData;
      if (contractStatus != '03') {
        this.$message.error('当前合同状态不支持变更主体');
        return;
      }
      // this.$refs.changPrimaryDialogRef.openDialog(rowData.id);
      this.closeHandler();
    },
    // 变更合同信息
    changeContractHandler() {
      if (!this.checkSelectOneData()) {
        return;
      }
      const rowData = this.selectionList[0];
      const { contractStatus, contractNo, id } = rowData;
      if (contractStatus != '03') {
        this.$message.error('当前合同状态不支持变更合同信息');
        return;
      }
      const path = {
        path: '/park/leaseContract/leaseContractChange',
        name: 'leaseContractChange',
        meta: {
          keepAlive: false,
          title: '三方仓库租赁合同变更',
        },
        query: {
          status: 'change',
          contractNo,
          id,
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 删除
    deleteHandler() {
      if (!this.selectionList.length) {
        this.$message.error('请选择要删除的行');
        return;
      }
      const statusCheck = this.selectionList.every((item) => item.contractStatus == '01');
      if (!statusCheck) {
        this.$message.error('只能删除已保存状态的单');
        return;
      }
      // 判断只有保存状态的菜可以删除
      const idList = this.selectionList.map((item) => item.id);
      this.$confirmAction('删除提示', '删除后将不可恢复，您确定要删除吗？')
        .then(async () => {
          const { data } = await this.$axios.post(`${leaseContractApi.DELETE_BY_ID}`, {
            ids: idList,
          });
          if (data.code == 0) {
            this.$message.success('删除成功');
            this.resetBtnClick();
          } else {
            this.$message.error('删除成功');
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 选择一行判断
    checkSelectOneData() {
      if (!this.selectionList.length) {
        this.$message.error('请选择一行操作');
        return false;
      }
      if (this.selectionList.length != 1) {
        this.$message.error('只能选择一行操作');
        return false;
      }
      return true;
    },
  },
};
